module.exports = __webpack_public_path__ + "img/protective_gear1.a8815651.png";